import defaultRegistry from "./default-registry";
import * as plugins from "./plugins";
import { combineReducers as combineReducersModule } from "./redux-store";
import { default as default2 } from "./components/with-select";
import { default as default3 } from "./components/with-dispatch";
import { default as default4 } from "./components/with-registry";
import {
  RegistryProvider,
  RegistryConsumer,
  useRegistry
} from "./components/registry-provider";
import {
  default as default5,
  useSuspenseSelect
} from "./components/use-select";
import { useDispatch } from "./components/use-dispatch";
import { AsyncModeProvider } from "./components/async-mode-provider";
import { createRegistry } from "./registry";
import { createRegistrySelector, createRegistryControl } from "./factory";
import { createSelector } from "./create-selector";
import { controls } from "./controls";
import { default as default6 } from "./redux-store";
import { dispatch } from "./dispatch";
import { select } from "./select";
const combineReducers = combineReducersModule;
const resolveSelect = defaultRegistry.resolveSelect;
const suspendSelect = defaultRegistry.suspendSelect;
const subscribe = defaultRegistry.subscribe;
const registerGenericStore = defaultRegistry.registerGenericStore;
const registerStore = defaultRegistry.registerStore;
const use = defaultRegistry.use;
const register = defaultRegistry.register;
export {
  AsyncModeProvider,
  RegistryConsumer,
  RegistryProvider,
  combineReducers,
  controls,
  default6 as createReduxStore,
  createRegistry,
  createRegistryControl,
  createRegistrySelector,
  createSelector,
  dispatch,
  plugins,
  register,
  registerGenericStore,
  registerStore,
  resolveSelect,
  select,
  subscribe,
  suspendSelect,
  use,
  useDispatch,
  useRegistry,
  default5 as useSelect,
  useSuspenseSelect,
  default3 as withDispatch,
  default4 as withRegistry,
  default2 as withSelect
};
//# sourceMappingURL=index.js.map
